
import {createAction} from "@reduxjs/toolkit";

export const Unauthorised = createAction('solar-man-api/401-unauthorised');

export default Unauthorised;
